import { ChangeEvent } from 'react'

const setInputValues = (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement> | any , state: object | string, updateState: Function) => {

    if (typeof state === 'string') {
            updateState(event.target.value)
    }
    
    /** Keep the state key name and input name same */
    if (typeof state === 'object') {
        const file = event.target.files?.[0];
        if(file){
            const maxSize = 10 * 1024 *1024  // 10 MB maximum file size
            if( file.size > maxSize){
                alert("Image size should not exceed 10MB")
                return
            }
            if( file.type !== "image/png" && file.type !== "image/jpeg" ){
                alert("Invalid Extension, Only png, jpg and jpeg allowed")
              }
              else{
                  updateState({value: file, src: URL.createObjectURL(file)})
              }
        }
        else{
            updateState({...state, [event.target.name]: event.target.value})
        }
        
    }
    
}

export default setInputValues